import React from 'react';

export default function CsfBrokerSearchConsent(props) {

  function getClassForConsent(consentId) {
    switch (consentId) {
      case 0:
        return 'pending-consent';
      case 1:
        return 'consent';
      case 2:
        return 'no-consent';
      case 3:
        return 'account-not-activated-consent';
      default:
        return '';
    }
  }

  return (
    <div className="table-wrapper">
      <table id="broker-consent-table">
        <caption className="sr-only">{window.Drupal.t('broker.consent.titlePage')}</caption>
        <thead>
          <tr>
            <th>
              {window.Drupal.t('broker.consent.header.certificateNumber')}
            </th>
            <th>
              {window.Drupal.t('broker.consent.header.name')}
            </th>
            <th>
              {window.Drupal.t('broker.consent.header.company')}
            </th>
            <th>
              {window.Drupal.t('broker.consent.header.consentStatus')}
            </th>
          </tr>
        </thead>

        <tbody>
          {props.data.length == 0 && (
            <tr>
              <td colSpan="5">
                <p>{window.Drupal.t('search.noResult')}</p>
              </td>
            </tr>
          )}

          {props.data.map((item, index) => (
            <tr key={`consent-table-row${index}`}>
              <td>
                {item.Member_Number}
              </td>
              <td>
                {item.Member_FirstName && item.Member_LastName && (
                  <>
                    {item.Member_FirstName.toLowerCase().replace(/(^|[\s-])([a-z])/g, (char) => char.toUpperCase()) + ' ' + item.Member_LastName.toLowerCase().replace(/(^|[\s-])([a-z])/g, (char) => char.toUpperCase())}
                  </>
                )}
              </td>
              <td>
                {item.company}
              </td>
              <td className="d-flex align-items-center justify-content-between">
                {item.Csf_crc_consent__Choice}
                <div className={`consent-status ${getClassForConsent(item.Csf_crc_consent)}`}>&nbsp;</div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
